import React, { Component, Fragment } from "react";
import getData from "../../data-services/api";
import { Paper } from "@material-ui/core";
import Lists from "../Home/Lists";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Loader from "../../components/CustomLoader";
import Grid from "@material-ui/core/Grid";
import SwipeableViews from "react-swipeable-views";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import UserLists from "./UserLists";
import { Header } from "../../components";
import client from "./../../utils/apolloClient";
import gql from "graphql-tag";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import "./SuperAdmin.css"

const queryString = require("query-string");
export default class SuperAdmin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: queryString.parse(window.location.search).tabIndex
                ? parseInt(queryString.parse(window.location.search).tabIndex, 10)
                : 0,
            profile: {},
            anchorEl: null,
            loading: true
        };
    }

    async componentDidMount() {

        const FCPUserQuery = `select id, sfid, name, heroku_id__c, sap_code__c from salesforce.account where recordtypeid = '0126F000001v2YtQAI'`;
        const CMDIUserQuery = `select id, sfid, name, cmdi_code__c, reporting_to_ammd__c from salesforce.pidilite_user__c where type__c = 'CMDI'`;
        const AMMDUserQuery = `select id, sfid, name, cmdi_code__c, reporting_to_ammd__c from salesforce.pidilite_user__c where type__c = 'AMMD'`;
        const ETTCUploadQuery = `SELECT SFId,name, ettc_document__c, ettc_download__c FROM Salesforce.Account Where ettc_document__c is not null 
                                    and recordtypeid = '0126F000001v2YtQAI'`;
        Promise.all([getData(FCPUserQuery), getData(CMDIUserQuery), getData(AMMDUserQuery), getData(ETTCUploadQuery)])
            .then(
                async ([FCPUserData, CMDIUserData, AMMDUserData, ETTCUploadData, ...data]) => {
                    this.setState({
                        profile: {
                            FCPUserData: FCPUserData.result,
                            CMDIUserData: CMDIUserData.result,
                            AMMDUserData: AMMDUserData.result,
                            ETTCUploadData: ETTCUploadData.result
                        },
                        loading: false
                    });
                }
            )

    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeIndex = index => {
        this.setState({ value: index });
    };

    handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    handleSettingdToggle = event => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleSignOut = () => {
        client
            .mutate({
                mutation: gql`
          mutation Logout {
            logout @client
          }
        `
            })
            .then(r => {
                this.props.history.replace("/signin");
            });
        if (localStorage.getItem('fcpLogoutMS') != '') {
            localStorage.removeItem('fcpLogoutMS');
        }
        localStorage.removeItem('token');
        localStorage.removeItem("FCPHPAList");
        localStorage.removeItem("authData");

    };

    // goBackPrev = () => {
    //     this.props.history.push({
    //         pathname: "/newHomeFCP"
    //     });
    // };

    render() {
        const { classes, history } = this.props;
        const { value, profile, loading, anchorEl } = this.state;
        return (

            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography
                                variant="title"
                                color="inherit"
                                className='text-center'
                            >
                                Super Admin
                            </Typography>
                        </Grid>
                        <Grid item xs={2} sm={2} md={2} >
                            <IconButton
                                aria-label="User Settings"
                                aria-owns={anchorEl ? "user-menu" : null}
                                aria-haspopup="true"
                                color="inherit"
                                onClick={this.handleSettingdToggle}
                                className="superAdmin_signOutButton"
                            >
                                <MoreVertIcon />
                            </IconButton>

                            <Menu
                                id="user-menu"
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={this.handleCloseMenu}
                                className="superAdmin_signOutButton"
                            >
                                <MenuItem onClick={this.handleCloseMenu}>
                                    <ListItemIcon>
                                        <ExitToAppIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        onClick={this.handleSignOut}
                                        inset
                                        primary="Sign out"
                                    />
                                </MenuItem>
                            </Menu>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {/* <Header /> */}
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        <div>
                            <Paper square={true}>
                                <Tabs
                                    value={value}
                                    onChange={this.handleChange}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="fullWidth"
                                >
                                    <Tab label={'FCP'} />
                                    <Tab label={'CMDI'} />
                                    <Tab label={'AMMD'} />
                                    <Tab label={'ETTC'} />
                                </Tabs>
                            </Paper>
                        </div>
                        <SwipeableViews
                            index={value}
                            onChangeIndex={this.handleChangeIndex}
                        >
                            <UserLists listitems={profile.FCPUserData} type="FCP" />
                            <UserLists listitems={profile.CMDIUserData} type="CMDI" />
                            <UserLists listitems={profile.AMMDUserData} type="AMMD" />
                            <UserLists listitems={profile.ETTCUploadData} type="ETTC" />
                            {/* <Lists listitems={profile.FCPUserData} />
                            <Lists listitems={profile.CMDIUserData} />
                            <Lists listitems={profile.AMMDUserData} /> */}
                        </SwipeableViews>
                    </>
                )}
            </>
        )
    }
}